var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncorrect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FFDEDE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2C17.7453 2 20.4202 2.86912 22.6412 4.48278L15 15V2Z",
    fill: "#DC3F16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncorrect);
export default __webpack_public_path__ + "static/media/incorrect.0207740adf13ed671430a616dc8e1bd7.svg";
export { ForwardRef as ReactComponent };